import React, { useState, useEffect } from 'react';
import Button from '../../../Components/Button';
import CardLayout from "../CommonLayout/CardLayout";
import PasswordStrengthChecker from '../../../Components/PasswordStrengthChecker';
import Validator from '../../../Components/Validator';
import useAxiosCall from '../../../Hooks/useAxiosCall';
import { SuccessAlert, ErrorAlert } from '../../../Components/Alert';
import { useNavigate, useLocation } from 'react-router-dom';
import { MDBCol, MDBRow } from 'mdb-react-ui-kit';
import constants from '../../../config/constants';
import PasswordInput from '../../../Components/PasswordInput';

const SetNewPassword = () => {
    const [formData, setFormData] = useState({
        newPassword: '',
        confirmPassword: ''
    });

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const passwordChangeId = queryParams.get('id');
    // const customer = queryParams.get('customer');
    const navigate = useNavigate();
    const [alert, setAlert] = useState({ type: '', message: '' });
    const [updated, setUpdated] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [guidData, setGuidData] = useState({});
    const [hasTyped, setHasTyped] = useState(false); // State to determine if user has started typing
    const [loginLink, setLoginLink] = useState("");
    const [logoImage, setLogoImage] = useState("");

    const [passwordChecks, setPasswordChecks] = useState({
        minLength: false,
        maxLength: false,
        upperCase: false,
        number: false,
        specialChar: false,
    });

    const validator = Validator();

    const handleInputChange = event => {
        const { name, value } = event.target;

        let newPasswordChecks = {};
        if (name === "newPassword") {
            setHasTyped(true);  // Set hasTyped to true once user starts typing in newPassword
            newPasswordChecks = {
                minLength: value.length > 7,
                maxLength: (value.length <= 20),
                upperCase: /[a-z]/.test(value) && /[A-Z]/.test(value),
                number: /\d/.test(value),
                specialChar: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value)
            };
            setPasswordChecks(newPasswordChecks);
        }
        setFormData(prevState => ({ ...prevState, [name]: value }));
    };

    const handleApiCallSuccess = (data) => {
        setAlert({ type: 'success', message: data.message });
        resetForm();
        setTimeout(() => {
            window.location.href = loginLink;
        }, 3000);
    };

    const handleApiCallError = (errorMessage) => {
        setAlert({ type: 'error', message: errorMessage });
    };
    const handleValidateApiCallSuccess = (data) => {
        setGuidData(data.data);
        createLoginLinkForPortal(data.data);
    };
    const createLoginLinkForPortal = (data) => {
        let userType = data.userType.toLowerCase();
        let url = constants.portalUrl;
        if (userType == "resident") {
            url += "resident/login/";
        } else if (userType == "owner") {
            url += "owner/login/";
        } else if (userType == "vendor") {
            url += "vendor/login/";
        }
        url += data.acctDbkey;
        setLogoImage(data.data.logo);
        setLoginLink(url);
    }

    const handleValidateApiCallError = (errorMessage) => {
        setAlert({ type: 'error', message: errorMessage });
        setDisableSubmit(true);
    };

    const resetForm = () => {
        setFormData({
            newPassword: '',
            confirmPassword: ''
        });
        setHasTyped(false);
        setUpdated(!updated);
    };

    const { makeApiCall } = useAxiosCall();

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (validator.allValid()) {
            try {
                const requestData = {
                    passwordChangeId: passwordChangeId,
                    newPassword: formData.newPassword,
                    confirmPassword: formData.confirmPassword,
                    email : formData.email
                };

                await makeApiCall({
                    requestData,
                    onSuccess: handleApiCallSuccess,
                    onError: handleApiCallError,
                    requestType: 'POST',
                    url: 'setUserNewPassword',
                });
            } catch (error) {
                console.error('API call error:', error);
            }
        } else {
            validator.showMessages();
            setUpdated(!updated);
        }
    };

    useEffect(() => {
        validateGuid()
    }, [passwordChangeId]);

    const redirectToLogin = () => {
        window.open(loginLink, "_blank");
    }

    const validateGuid = async() => {
        try {
            const requestData = {
                guid: passwordChangeId,
            };
            await makeApiCall({
                requestData,
                onSuccess: handleValidateApiCallSuccess,
                onError: handleValidateApiCallError,
                requestType: 'POST',
                url: 'validateGuid',
            });
        } catch (error) {
            console.error('API call error:', error);
        }
    }

    return (
        // <CardLayout title={"Welcome to "+(Object.keys(guidData).length > 0 ? ucwords(guidData.userType) : "")+" Portal" }>
        <CardLayout title={"Set New Password"} logo={logoImage} customerLogo={true}>
            {alert.type === 'success' && <SuccessAlert success={true} messages={[alert.message]} resetAlert={setAlert} />}
            {alert.type === 'error' && <ErrorAlert error={true} messages={[alert.message]} resetAlert={setAlert} />}
            <form onSubmit={handleSubmit} noValidate>

                <FieldWrapper>
                    <PasswordInput
                        id="newPassword"
                        name="newPassword"
                        label="New Password"
                        value={formData.newPassword}
                        onChange={handleInputChange}
                    />
                    {validator.message('newPassword', formData.newPassword, 'newPasswordRequired|passwordLength')}
                    {hasTyped && validator.message('newPassword', formData.newPassword, 'passwordStrength')}
                    {hasTyped && <PasswordStrengthChecker checks={passwordChecks} />}
                </FieldWrapper>

                <FieldWrapper>
                    <PasswordInput
                        id="confirmPassword"
                        name="confirmPassword"
                        label="Confirm New Password"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                    />
                    {validator.message('confirmPassword', formData.confirmPassword, 'confirmPasswordRequired|passwordLength')}
                    {validator.message('passwords', formData, 'passwordsMatch')}
                </FieldWrapper>

                <Button type="submit" block disabled={disableSubmit} className="mb-4">Reset Password</Button>
            </form>
            <div className="mt-3">
                <MDBRow>
                    <MDBCol size="8" className="md-8">
                        {/* <p className="text-left">For Client Care, please call 864-297-7661 x2</p> */}
                    </MDBCol>
                    {loginLink != '' && <MDBCol size="4" className="md-4">
                        <span className="text-primary cursor-pointer text-right" onClick={redirectToLogin}>
                            Go to Login
                        </span>
                    </MDBCol>}
                </MDBRow>
            </div>
        </CardLayout>
    );
};


const FieldWrapper = ({ children }) => (
    <div className="mb-4">{children}</div>
);

export default SetNewPassword;
